export default __webpack_public_path__ + "static/corony-109fe2e1ae33aa66059c3cdd8ccaf7e3.png";